<template>
  <a
    :data-bs-toggle="collapse ? 'collapse' : ''"
    :href="collapse ? `#${collapseRef}` : collapseRef"
    :aria-controls="collapseRef"
    :aria-expanded="isExpanded"
    class="nav-link"
    v-bind="$attrs"
    type="button"
    @click.prevent.stop="this.isExpanded = !this.isExpanded"
  >
    <div class="text-center d-flex align-items-center justify-content-center">
      <div class="collapse-icon">
        <slot name="icon"></slot>
      </div>
    </div>
    <span
      class="nav-link-text"
      :class="this.$store.state.isRTL ? ' me-3' : 'ms-3'"
    >
      <slot name="label">{{ navText }}</slot>
    </span>
  </a>
  <div :class="isExpanded ? 'collapse show' : 'collapse'">
    <slot name="list"></slot>
  </div>
</template>
<script>
export default {
  name: "sidenav-collapse",
  props: {
    collapseRef: {
      type: String,
      required: true,
    },
    navText: {
      type: String,
      required: true,
    },
    collapse: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isExpanded: false,
    };
  },
};
</script>
<style lang="scss">
.collapse-icon {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
  padding: 3px;

  img,
  svg {
    width: 100%;
    height: 100%;
    max-width: 100%;
    object-fit: contain;
  }
}
</style>
